import { JobBlock } from '@/lib/types';

import JobBlocks from '@/features/job-blocks';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import SpecialtyJobBlocksRenderer from '@/features/specialty-page/hygraph/renderers/specialty-job-blocks.renderer';
import jobBlocksTransformer from '@/hygraph/transformers/job-blocks.transformer';

export default function JobBlocksRenderer(props: JobBlock) {
  const isSpecialtyPage = !!useSpecialtyPageContext().specialty;
  if (isSpecialtyPage) {
    return <SpecialtyJobBlocksRenderer {...props} />;
  }

  return <JobBlocks {...jobBlocksTransformer(props)} />;
}
